import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssignedDriver, AssignedVehiclesPaginatedRequest, AssignRequest, UnassignRequest } from "../models/vehicle-assignment.model";
import { environment } from "../../../../environments/environment";
import { Pagination, Response } from '../../../_shared/models';
import { firstValueFrom, Subject, takeUntil } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VehicleAssignmentService {

  constructor(private http: HttpClient) { }

  public getDriverAssignments(request: AssignedVehiclesPaginatedRequest, cancellation: Subject<void>): Promise<Response<Pagination<AssignedDriver[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/vehicleassignment/search-drivers`, request).pipe(takeUntil(cancellation)));
  }

  public unassignVehicles(request: UnassignRequest): Promise<any> {
    return firstValueFrom(this.http.post<Response<any>>(`${environment.apiEndpoint}/vehicleassignment/unassign-drivers`, request));
  }

  public assignVehicles(request: AssignRequest): Promise<any> {
    return firstValueFrom(this.http.post<Response<any>>(`${environment.apiEndpoint}/vehicleassignment/assign-drivers`, request));
  }
}